module.exports = __webpack_public_path__ + "img/jt.c268bab5.png";